import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    select: {
        '& fieldset': {
            borderColor: '#d8d6d6',
            borderWidth: 2,
        },
    },
}));

export default useStyles;